var _g;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.9446 20.4016C27.594 20.4868 26.5589 21.61 26.6404 22.9019L26.6683 23.3447C26.3487 23.7144 25.914 24.3949 25.971 25.2989C26.013 25.9647 26.305 26.4768 26.5997 26.8292C26.3516 27.2158 26.1263 27.7605 26.1683 28.4263C26.2254 29.3303 26.7421 29.9508 27.1057 30.2774L27.1337 30.7202C27.2152 32.0121 28.3832 32.9963 29.7338 32.911L35.8641 32.5243C36.1387 32.5069 36.2346 32.553 36.2409 32.5526C36.2628 32.5942 36.2981 32.7974 36.1637 33.2075C35.2322 36.075 34.9656 37.7935 35.0327 38.8563C35.0573 39.2472 35.2111 40.415 36.3574 40.3427C37.5164 40.2695 38.093 39.1968 38.1241 39.1304L42.6768 31.7756C43.2346 30.9125 43.4958 29.921 43.4319 28.907L43.1112 23.8251C42.9617 21.4551 40.822 19.6523 38.3444 19.8086L28.9446 20.4016Z",
    fill: "#E36667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9981 8.80228C12.0294 8.73898 12.6061 7.66622 13.7651 7.5931C14.9113 7.52078 15.0651 8.6885 15.0898 9.07942C15.1568 10.1422 14.8902 11.8608 13.9588 14.7282C13.8244 15.1384 13.8596 15.3416 13.8815 15.3831C13.8879 15.3827 13.9838 15.4288 14.2583 15.4115L20.3887 15.0247C21.7392 14.9395 22.9071 15.9206 22.9888 17.2155L23.0167 17.6584C23.3803 17.985 23.8969 18.6024 23.9541 19.5095C23.9961 20.1752 23.7706 20.7169 23.5228 21.1066C23.8175 21.459 24.1094 21.971 24.1514 22.6368C24.2085 23.5408 23.7738 24.2213 23.4541 24.5911L23.482 25.0339C23.5635 26.3258 22.5285 27.4489 21.1779 27.5341L11.7781 28.1272C9.3004 28.2835 7.16073 26.4806 7.0112 24.1107L6.69058 19.0287C6.62661 18.0148 6.88782 17.0233 7.44563 16.1602L11.9981 8.80228Z",
    fill: "#21BB71"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNeutral);
export default __webpack_public_path__ + "static/media/badge_neutral.c7f4951c.svg";
export { ForwardRef as ReactComponent };